/* MBG: every link that leaves the store opens in a new tab (target=_blank rel="noopener noreferrer").
   Covers theme buttons, menus, footer, rich text, article bodies and anything added later.
   Internal = the store's own hosts (+ *.shopify.com). mailto/tel/sms/# are left alone.
   /book is treated as external because it redirects to the booking platform. */
(function () {
  var own = [location.hostname, 'www.' + location.hostname.replace(/^www\./, ''), location.hostname.replace(/^www\./, '')];
  if (window.Shopify && Shopify.shop) own.push(Shopify.shop);
  // add the live custom domain here at build time, e.g. 'saltsalonantioch.com'
  (window.MBG_OWN_HOSTS || ['saltsalonantioch.com', 'www.saltsalonantioch.com']).forEach(function (h) { own.push(h); });
  var BOOK = /^\/book(\/|$)/;
  function external(a) {
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(raw)) return false;
    var u; try { u = new URL(a.href, location.href); } catch (e) { return false; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    var h = u.hostname;
    var inside = own.indexOf(h) > -1 || /(^|\.)shopify\.com$/.test(h) || /(^|\.)myshopify\.com$/.test(h);
    if (inside) return BOOK.test(u.pathname);
    return true;
  }
  function mark(a) {
    if (a.getAttribute('data-mbg-ext')) return;
    if (!external(a)) return;
    a.setAttribute('target', '_blank');
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (r) { if (rel.indexOf(r) < 0) rel.push(r); });
    a.setAttribute('rel', rel.join(' '));
    a.setAttribute('data-mbg-ext', '1');
  }
  function scan(root) { (root.querySelectorAll ? root : document).querySelectorAll('a[href]').forEach(mark); }
  function start() {
    scan(document);
    new MutationObserver(function (m) {
      m.forEach(function (x) {
        x.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'A') mark(n); scan(n); } });
        if (x.type === 'attributes' && x.target.tagName === 'A') { x.target.removeAttribute('data-mbg-ext'); mark(x.target); }
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
